import { service } from '../../../../helpers/http' 

export const ActionGetCustomerContracts = ({ dispatch }, payload) => { 
    return service({
        module: 'customerContract',
        action: 'getCustomerContracts',
        payload: payload
    })
}

export const ActionPostCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'postCustomerContracts',
        payload: payload
    })
    
}

export const ActionPutCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'putCustomerContracts',
        payload: payload
    })
    
}

export const ActionDeleteCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'deleteCustomerContracts',
        payload: payload
    })
    
}